var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.clearDrawing}},[_vm._v("clear")]),_c('svg',{ref:"drawingCanvas",staticClass:"svg-content",attrs:{"version":"1.1","viewBox":"0 0 100 100"}},_vm._l((_vm.item),function(line,index){return _c('path',{key:index,attrs:{"d":_vm.pathFor(line)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }